<div class="app-titulo-pagina">
    <span>Loja</span>
</div>

<h3>Meu Carrinho</h3>

<div class="container">
    <div class="col-xs-12 col-sm-6 col-sm-offset-3"
         *ngIf="!(mainService.lojaCarrinho.itens.length !== 0)">
        <h5>
            Seu carrinho está vazio!<br>Clique em continuar na loja para escolher seus produtos!
        </h5>
        <a (click)="router.navigate(['/loja/vitrine']);"
           class="btn app-btn-best btn-block">
            <i class="fa fa-arrow-left"></i> Continuar na Loja
        </a>
    </div>

    <div *ngIf="!processando && mainService.lojaCarrinho.itens !== undefined && mainService.lojaCarrinho.itens.length !== 0">
        <div class="col-xs-12 col-sm-6 form-group" 
             *ngIf="!(mainService.lojaCarrinho.itens.length !== 0)">
            <button (click)="limparCarrinho()"
                    *ngIf="(mainService.lojaCarrinho.itens.length !== 0)"
                    class="btn app-btn-best btn-block">
                <i class="fa fa-trash"></i> Limpar Carrinho
            </button>
        </div>
        <div *ngIf="(mainService.lojaCarrinho.itens.length !== 0)">
            <div id="no-more-tables">
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Codigo Produto</th>
                            <th>Nome</th>
                            <th>Valor Unitario</th>
                            <th>Quantidade</th>
                            <th>Valor Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of mainService.lojaCarrinho.itens">
                            <td data-title="Codigo Produto">{{ item.produto.sku }}</td>
                            <td data-title="Nome">{{ item.produto.nome }}</td>
                            <td data-title="Valor Unitario">{{ item.produto.pontos }}</td>
                            <td data-title="Quantidade" style="white-space: nowrap">
                                <button class="btn app-btn-best"
                                        (click)="removerItemCarrinho(item.produto); limparFrete()">
                                    <i class="fa fa-minus"></i>
                                </button>
                                {{ item.quantidade }}
                                <button class="btn app-btn-best"
                                        (click)="mainService.lojaCarrinho.add(item.produto); limparFrete()">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </td>
                            <td data-title="Valor Total">{{ item.produto.pontos * item.quantidade }}</td>
                        </tr>
                    </tbody>
                    <tfoot class="hidden-xs app-hidden ">
                        <tr>
                            <th></th>
                            <th>Total em Produtos</th>
                            <th></th>
                            <th>{{ mainService.lojaCarrinho.totalItens() }}</th>
                            <th>{{ mainService.lojaCarrinho.totalPontos() }}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <div class="row visible-xs" style="margin-bottom: 10px;">
                <div class="col-xs-12 ">
                    <div class="app-table-especial">
                        <span class="text-left" style="width: 50%;"><strong>Total de Itens:</strong></span>
                        <span class="text-right"style="width: 40%;">{{ mainService.lojaCarrinho.totalItens() }}</span>
                    </div>
                </div>
                <div class="col-xs-12 ">
                    <div class="app-table-especial">
                        <span class="text-left" style="width: 50%;"><strong>Total de Resgate:</strong></span>
                        <span class="text-right"style="width: 40%;">{{ mainService.lojaCarrinho.totalPontos() }}</span>
                    </div>
                </div>
            </div>

            <div class="col-xs-12">
                <div class="col-xs-12 col-sm-6 form-group">
                    <a (click)="router.navigate(['/loja/vitrine'])"
                       class="btn app-btn-best btn-block">
                        <i class="fa fa-arrow-left"></i> Continuar na Loja
                    </a> 
                </div>

                <div class="col-xs-12 col-sm-6 form-group">
                    <button (click)="limparCarrinho()"
                            *ngIf="(mainService.lojaCarrinho.itens.length !== 0)"
                            class="btn app-btn-best btn-block"
                            id="btn-limpar-carrinho">
                        <i class="fa fa-trash"></i> Limpar Carrinho
                    </button>
                </div>
            </div>
    
            <div class="col-xs-12 col-sm-4 col-sm-offset-4">
                <h6>Calcular frete:</h6>
                <div class="input-group">
                    <span class="input-group-addon">CEP:</span>
                    <input [(ngModel)]="cep"
                           (ngModelChange)="limparFrete()"
                           type="text"
                           id="cep"
                           uiCep
                           uiEnter="buscarCep"
                           placeholder="00000000"
                           class="form-control input-sm"
                           required>
                    <span class="input-group-btn">
                        <button (click)="calcularFrete()"
                                type="button"
                                id="buscarCep"
                                class="btn app-btn-best btn-sm">
                        <span class="glyphicon glyphicon-search" aria-hidden="true"></span></button>
                    </span>
                </div>
            </div>

            <div *ngIf="(freteOpcoes.length !==0)">
                <div class="col-xs-12">
                    <div *ngFor="let opcao of freteOpcoes">
                        <div class="radio">
                            <label for="{{ opcao.descricao }}">
                                <input type="radio"
                                       name="frete"
                                       id="{{ opcao.descricao }}"
                                       (change)="setFrete(opcao)"
                                       required>
                                {{ opcao.descricao + ' por ' + opcao.frete.pontos + ' pontos em '
                                    + opcao.previsaoEntrega }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="opcaoFrete && !processando"
         class="col-xs-12">
        <h2>Dados Entrega</h2>
        <h4>{{ 'Confira as informações abaixo e conclua sua compra.'| uppercase }}</h4>

        <div class="app-vale-presente-bordas"
             style="margin-top: 2em;">
            <div class="col-xs-12 col-md-6 app-borda-divisora">
                <div class="col-xs-12 text-left">
                    Destinatário
                </div>

                <div class="form-group col-xs-12">
                    <label for="destinatario">Nome:</label>
                    <input [(ngModel)]="mainService.lojaCarrinho.destinatario.nome"
                           [readonly]="isPessoaFisica()"
                           type="text"
                           id="destinatario"
                           class="form-control input-sm"
                           required>
                </div>

                <div class="form-group col-xs-12 col-md-6">
                    <label for="destinatarioCPF">CPF: </label>
                    <input [(ngModel)]="mainService.lojaCarrinho.destinatario.documento"
                           [readonly]="isPessoaFisica()"
                           type="text"
                           id="destinatarioCPF"
                           class="form-control input-sm"
                           uiCpf
                           placeholder="00000000000"
                           required>
                </div>

                <div class="form-group col-xs-12 col-md-6">
                    <label for="destinatario.telefone">Telefone</label>
                    <input [(ngModel)]="mainService.lojaCarrinho.destinatario.telefone"
                           [readonly]="isPessoaFisica()"
                           type="tel"
                           id="destinatario.telefone"
                           class="form-control input-sm"
                           uiTel
                           placeholder="(11)11111111"
                           required>
                </div>

                <div class="form-group col-xs-12">
                    <label for="destinatario.email">Email:</label>
                    <input [(ngModel)]="mainService.lojaCarrinho.destinatario.email"
                           [readonly]="isPessoaFisica()"
                           type="email"
                           placeholder="seuemail@seuemail.com.br"
                           id="destinatario.email"
                           class="form-control input-sm"
                           required>
                </div>
            </div>

            <div class="col-xs-12 col-md-6">
                <div class="col-xs-12 text-left">
                    Endereço de Entrega
                </div>

                <div class="form-group col-xs-12">
                    <label for="logradouro">Logradouro</label>
                    <input [readonly]="logradouroIsReadOnly"
                           [(ngModel)]="mainService.lojaCarrinho.enderecoEntrega.logradouro"
                           type="text"
                           id="logradouro"
                           class="form-control input-sm"
                           required>
                </div>
                <div class="form-group col-xs-4 col-md-4">
                    <label for="numero">Número</label>
                    <input [(ngModel)]="mainService.lojaCarrinho.enderecoEntrega.numero"
                            name="numeroEnderecoEntrega"
                           type="text"
                           id="numero"
                           class="form-control input-sm"
                           maxlength="64">
                </div>
                <div class="form-group col-xs-8 col-md-8">
                    <label for="complemento">Complemento</label>
                    <input [(ngModel)]="mainService.lojaCarrinho.enderecoEntrega.complemento"
                           name="enderecoComplemento"
                           type="text"
                           id="complemento"
                           class="form-control input-sm"
                           maxlength="256">
                </div>
                <div class="form-group col-xs-12 col-md-5">
                    <label for="bairro">Bairro</label> 
                    <input [(ngModel)]="mainService.lojaCarrinho.enderecoEntrega.bairro"
                           [readonly]="bairroIsReadOnly"
                           type="text"
                           id="bairro"
                           class="form-control input-sm"
                           required>
                </div>
                <div class="form-group col-xs-8 col-md-5">
                    <label for="cidade">Cidade</label>
                    <input [(ngModel)]="mainService.lojaCarrinho.enderecoEntrega.cidade"
                           type="text"
                           id="cidade"
                           class="form-control input-sm"
                           readonly>
                </div>
                <div class="form-group col-xs-4 col-md-2">
                    <label for="uf">UF</label>
                    <input [(ngModel)]="mainService.lojaCarrinho.enderecoEntrega.uf"
                           type="text"
                           id="uf"
                           class="form-control input-sm"
                           readonly>
                </div>
            </div>

          <div class="col-xs-12 col-md-6 col-md-offset-3"
                 style="margin-top: 2em;">
                <div class="form-group col-xs-12 col-md-6">
                    <label for="pontosTotais">Produtos em pontos</label>
                    <input type="text"
                           id="pontosTotais"
                           value="{{ mainService.lojaCarrinho.totalPontos() }}"
                           class="form-control input-sm"
                           readonly>
                </div>
                <div class="form-group col-xs-12 col-md-6">
                    <label for="fretePontos">Frete em pontos</label>
                    <input type="text"
                           id="fretePontos"
                           value="{{ opcaoFrete.frete.pontos }}"
                           class="form-control input-sm"
                           readonly>
                </div>
                   <div class="form-group col-xs-12 col-md-6">
                    <label for="totalPontos">Total em pontos</label>
                    <input type="text"
                           id="totalPontos"
                           value="{{ totalPontos() }}"
                           class="form-control input-sm"
                           readonly>
                </div>
                <div class="form-group col-xs-12 col-md-6">
                    <label for="ep">Senha eletrônica </label>
                    <input [(ngModel)]="senhaEletronica"
                           type="password"
                           id="ep"
                           class="form-control input-sm">
                </div>
                <div class="form-group col-xs-12 col-md-12 alert alert-warning app-aviso-entrega"
                     role="alert"
                     *ngIf="(pedidos.length!==0)">
                    <p class="text-center">
                        Caro premiado,
                        <br/>
                        Ao receber os itens, se possível verifique se o mesmo encontra-se em perfeitas 
                            condições antes de dispensar o entregador.
                        <br/>
                        Caso o item esteja danificado devolver o mesmo ao entregador e nos avisar 
                            pelo PicPontos o ocorrido para que possamos solicitar a troca.
                    </p>
                </div>
                <button *ngIf="!processando"
                        (click)="save()"
                        class="btn btn-success-v2"
                        id="btn-concluir-compra">
                    Concluir Compra
                </button>
            </div>
        </div>
    </div>

    <div *ngIf="processando"
         class="text-center">
        <i class="fa fa-spinner fa-pulse fa-4x"></i>
    </div>
</div>
<div class="clearfix"></div>


// WEBPACK FOOTER //
// ./src/app/loja/loja-carrinho/loja-carrinho.component.html